import { playerIdNameParser } from '../commonInbounds/utils/playerInboundUtils';
import { parseInboundPayload } from '../inbound';
import { createArrayWithBracesParser, numberParser } from '../inboundParsers';
import { trimBraces } from '../inboundUtils';
export const DIRECT_MESSAGES_RECENT_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [{ name: 'recentConversations', parser: createArrayWithBracesParser(recentConversationParser) }]
};
function recentConversationParser(str) {
    const inboundParts = trimBraces(str).split(',');
    return parseInboundPayload(inboundParts, recentConversationPartDefinitions);
}
const recentConversationPartDefinitions = [
    { name: 'playerIdName', parser: playerIdNameParser },
    { name: 'timestampMs', parser: numberParser }
];
